import { matchPath, PathMatch } from 'react-router'
import { BreadcrumbData } from 'use-react-router-breadcrumbs'

import { hubRoutes } from 'routes/hub'
import { IHubRouteBuilder } from 'routes/hub/contract'
import { ROUTES } from 'sharedKernel/constants'

export const filterBreadcrumbs = (breadcrumbs: BreadcrumbData[]): any => {
  const filteredBreadcrumbs: any = []

  breadcrumbs.forEach((crumb) => {
    hubRoutes.every((route: IHubRouteBuilder) => {
      let match
      if ((match = getCrumbMatchWithSystemRoute(route, crumb)) !== null) {
        const breadcrumbName = typeof route.breadcrumb === 'function'
          ? route.breadcrumb()
          : route.breadcrumb
        if (!filteredBreadcrumbs.find(b => b.name === breadcrumbName)) {
          filteredBreadcrumbs.push({ name: breadcrumbName, path: `/hub${String(match.pathname)}` })

          return false
        }
      }

      return true
    })
  })

  return filteredBreadcrumbs
}

const getCrumbMatchWithSystemRoute = (route: any, crumb: any): PathMatch | null => {
  const pathname = crumb.location.pathname.replace('/hub', '')
  if (pathname.includes('/public-administration/') && route.path === ROUTES.HUB.COMPANY.ECOSYSTEM_STARTUP) {
    return null
  }
  return matchPath({ path: route.path, caseSensitive: false, end: false }, pathname)
}
